import React, { useEffect } from 'react';
import Loading from '@nebula/loading';
import {
  LoaderContainer,
  LoaderSubTitle,
  LoaderTextContainer,
  LoaderTitle,
  NebulaLoadingContainer,
  PageContainer,
} from './index.styles';

const NewLoading = ({ isWebview }: { isWebview: boolean }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageContainer isWebview={isWebview}>
      <LoaderContainer>
        <NebulaLoadingContainer>
          <Loading />
        </NebulaLoadingContainer>
        <LoaderTextContainer>
          <LoaderTitle>Updating your account</LoaderTitle>
          <LoaderSubTitle>Please do not refresh or leave this screen</LoaderSubTitle>
        </LoaderTextContainer>
      </LoaderContainer>
    </PageContainer>
  );
};
export default NewLoading;
